import React from "react";

const PlanningTypeInfo = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Planner Functionality Types</h2>
      <p className="mb-4">
        In the following, we name and define each type of planner functionality.
        Most names follow the terminology adopted in the AI planning field.
      </p>
      <ul className="list-disc ml-6">
        <li>
          <strong>Modelling:</strong> Enables users to manually specify planning problems textually using a given modelling language or using graphical notations.
        </li>
        <li>
          <strong>Knowledge Learning:</strong> Automatically acquires planning domain models, heuristics, and other forms of planning control knowledge.
        </li>
        <li>
          <strong>Parsing:</strong> Analyses whether planning problems conform to the rules of the chosen modelling language.
        </li>
        <li>
          <strong>Conversion:</strong> Transforms planning data from one form to another, e.g., planning domain models to programming-level objects.
        </li>
        <li>
          <strong>Problem Generation:</strong> Automatically produces instances of planning problems using real-time data representing the world (e.g., Internet of Things data).
        </li>
        <li>
          <strong>Plan Generation (or Solving):</strong> Computes plans as solutions to planning problems.
        </li>
        <li>
          <strong>Searching:</strong> Is concerned with a search algorithm used to explore the space of possible solutions to planning problems.
        </li>
        <li>
          <strong>Learning:</strong> Aids the planning process using machine learning techniques.
        </li>
        <li>
          <strong>Strategising:</strong> Employs strategies, such as heuristics and preferences, to quickly find plans, find approximate plans, or improve plan quality.
        </li>
        <li>
          <strong>Translation:</strong> Translates planning problems into other types of problems.
        </li>
        <li>
          <strong>Execution:</strong> Is responsible for executing plan actions.
        </li>
        <li>
          <strong>Monitoring:</strong> Is used to observe the world in which plans are executed and detect potential contingencies during plan execution.
        </li>
        <li>
          <strong>Tolerance:</strong> Is responsible for handling unexpected events or contingencies during execution of plans (e.g., action execution fails due to network issues).
        </li>
        <li>
          <strong>Plan Validation:</strong> Validates the correctness of plans.
        </li>
        <li>
          <strong>Explanation:</strong> Is used to explain planning to users, such as planning steps, the inclusion of actions in some plan, and their plan order.
        </li>
        <li>
          <strong>Visualisation:</strong> Provides the means to display information, such as charts, tables, and other statistics relevant to planning.
        </li>
        <li>
          <strong>Data:</strong> Offers a permanent storage of planning domain models and data.
        </li>
        <li>
          <strong>System Management:</strong> Offers routing of messages from one point to another and/or handling systems errors and failures.
        </li>
        <li>
          <strong>System Monitoring:</strong> Enables users to monitor a planning system.
        </li>
      </ul>
    </div>
  );
};

export default PlanningTypeInfo;
